import AppConstant from '../../../../../config/app.constants';
import BaseController from '../common/environment_config.base.controller'

class EnvironmentConfigCreateController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, EnvironmentConfigService, Modal, $translate, CommonLayoutService, Idle) {
        super(Auth, $state, User, EnvironmentConfigService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.EnvironmentConfigService = EnvironmentConfigService;
        this.CommonLayoutService = CommonLayoutService;
        this.Idle = Idle;

        this.defaultModel = {
            currentBranch: this.User.getUser().branchId,
            otcConfig: [],
            googleMapFrontEndKey: null,
            googleMapBackEndKey: null,
            ETADistanceKey: null,
            routificApiKey: null,
            enableRoutific: false,
            pageTitle: null,
            webUrl: null,
            companyName: null,
            companyLogo: [],
            printLogo: [],
            selectedFiles: [],
            printFromLocationName: null,
            printFromLocationAddress: null,
            generateXMLFile: false,
            generateCSVFile: false,
            communicationPassword: null,
            cryptographyPassword: null,
            masterPassword: null,
            OTCUserSync: false,
            enable2FA: false,
            maintainDriveDistance: false,
            companyAddress: null,
            companyPhoneNumber: null,
            companyEmail: null,
            footerText: null,
            sessionLength: null,
            routeOptimizationEngine: null,
            bagOutScanLimit: null
        }

        this.model = angular.copy(this.defaultModel);

        this.serviceOrderParts = {
            results: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            }
        };

        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no'),
            },
            onColor: 'success',
            offColor: 'danger'
        };

        this.routeOptimizationEngine = [
            { value: 'routific', label: 'Routific' },
            { value: 'google_maps', label: 'Google Maps' }
        ];

        this.passWdIcon = {};
        this.passwordStats = ['NFC', 'OTC'];
    }

    $onInit() {
        this.loadData();
        this.passwordStats.forEach((stat) => {
            if (stat === 'NFC') this.passWdIcon[stat] = { communicationPassword: false, cryptographyPassword: false, masterPassword: false };
            else if (stat === 'OTC') this.passWdIcon[stat] = {};
        })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
    }

    create() {
        let OtcConfig = {}, googleMapConfig = { maps: {} }, routific = {}, assets = {}, companyLogo = [], printLogo = [],
            bagoutManifestConfig = {}, NFCConfig = {}, cronSchedulerConfig = {};

        this.loading = true;
        this.model.otcConfig.forEach((otc) => {
            OtcConfig = Object.assign(OtcConfig, {
                [otc.companyName]: {
                    company: otc.companyName,
                    user: otc.user,
                    passwd: otc.password,
                    disableLockStatus: otc.disableLockStatus,
                    options: {
                        secure: otc.secure,
                        hostname: otc.hostName
                    }
                },
            })
        })

        googleMapConfig.maps = {
            backend: {
                key: this.model.googleMapBackEndKey
            },
            frontend: {
                key: this.model.googleMapFrontEndKey
            },
            maintainDriveDistance: this.model.maintainDriveDistance,
            ETADistanceKey: {
                key: this.model.ETADistanceKey
            }
        }

        routific = {
            enable: this.model.enableRoutific,
            token: this.model.routificApiKey
        }

        assets = {
            pageTitle: this.model.pageTitle,
            companyName: this.model.companyName,
            printFromLocationName: this.model.printFromLocationName,
            printFromLocationAddress: this.model.printFromLocationAddress,
            companyAddress: this.model.companyAddress,
            companyPhoneNumber: this.model.companyPhoneNumber,
            companyEmail: this.model.companyEmail,
            footerText: this.model.footerText
        }

        bagoutManifestConfig = {
            generateXMLFile: this.model.generateXMLFile,
            generateCSVFile: this.model.generateCSVFile,
            bagOutScanLimit: this.model.bagOutScanLimit
        }

        NFCConfig = {
            communicationPassword: this.model.communicationPassword,
            cryptographyPassword: this.model.cryptographyPassword,
            masterPassword: this.model.masterPassword
        }

        cronSchedulerConfig = {
            OTCUserSync: this.model.OTCUserSync
        }

        if (this.model.companyLogo && this.model.companyLogo.length) {
            this.model.companyLogo.forEach((d) => {
                this.model.companyLogoMetaData = {
                    lastModified: d._file.lastModified,
                    lastModifiedDate: d._file.lastModifiedDate,
                    name: d._file.name,
                    size: d._file.size,
                    type: d._file.type,
                }
                companyLogo.push({ base64String: d.base64Data, fileName: d.fileName });
            })
        }

        if (this.model.printLogo && this.model.printLogo.length) {
            this.model.printLogo.forEach((d) => {
                this.model.printLogoMetaData = {
                    lastModified: d._file.lastModified,
                    lastModifiedDate: d._file.lastModifiedDate,
                    name: d._file.name,
                    size: d._file.size,
                    type: d._file.type,
                }
                printLogo.push({ base64String: d.base64Data, fileName: d.fileName });
            })
        }

        this.Service.create({
            OTCAnywhere: OtcConfig,
            googleMapKeys: googleMapConfig,
            routific,
            assets,
            companyLogo,
            companyLogoMetaData: this.model.companyLogoMetaData,
            printLogo,
            printLogoMetaData: this.model.printLogoMetaData,
            companyName,
            branchId: this.model.currentBranch,
            bagoutManifestConfig,
            NFCConfig,
            cronSchedulerConfig,
            enable2FA: this.model.enable2FA,
            sessionLength: this.model.sessionLength,
            routeOptimizationEngine: this.model.routeOptimizationEngine
        })
            .then(() => {
                this.CommonLayoutService.setUIConfig(assets);
                window.history.go(-1);
                if(this.model.sessionLength){
                    this.Idle.watch()
                    this.Idle.setIdle(this.model.sessionLength * 60);
                    localStorage.setItem('sessionLength', JSON.stringify(this.model.sessionLength))
                } else {
                    this.Idle.unwatch()
                    localStorage.removeItem('sessionLength')
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.loading = false;
            })
    }

    setPasswordMap(stat, type) {
        if (stat === 'OTC') {
            this.passWdIcon[stat][type] = { viewPass: false };
        }
    }

    viewPassword(stat, type, field) {
        this.CommonLayoutService.viewPassword(stat, type, field, this.passWdIcon);
    }

    addOTCConfig() {
        this.model.otcConfig.push({
            companyName: null,
            user: null,
            password: null,
            secure: true,
            hostName: null,
            disableLockStatus: false
        });
        this.validateOTCConfig();
    }

    removeOTCConfig(index) {
        this.model.otcConfig.splice(index, 1);
        this.validateOTCConfig();
    }

    validateOTCConfig() {
        this.model.otcConfig = _.map(this.model.otcConfig, (obj, index) => {
            obj.isDuplicate = false;
            let match = _.find(this.model.otcConfig, (compairObject, compairObjIndex) => {
                if (index > compairObjIndex) return compairObject.companyName == obj.companyName;
            });
            if (match) {
                obj.isDuplicate = true;
                return obj;
            } else {
                return obj;
            }
        });
        let isValidDirective = this.model.otcConfig.map((obj) => {
            if (obj.isDuplicate) return true;
        })
        this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
    }

    loadData() {
        this.gettingDetails = true;
        this.Service.details()
            .then((data) => {
                this.environmentConfig = data.results;
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.gettingDetails = false;
            })
    }

    viewAppLogo(data, stat) {
        this.Modal.viewAppLogo(data, stat, ({ modal }) => {
        }, ({ modal }) => {
            modal.close();
        });
    }

    isValid() {
        if(this.model.sessionLength === null) return true;
        // Check if the value is undefined or null
        if (this.model.sessionLength === undefined) {
          return false;
        }
      
        // Convert the value to a number and check if it's a valid number
        const sessionLength = Number(this.model.sessionLength);
        if (isNaN(sessionLength) || sessionLength < 1) {
          return false;
        }
      
        // Check if the value is a positive integer
        return /^[1-9]\d*$/.test(this.model.sessionLength.toString());
      }
}

export default EnvironmentConfigCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/create/environment_config.create.controller.js